import E, { useState as A, useRef as k, useEffect as M } from "react";
import { useI18n as q } from "next-localization";
import { u as z, i as N } from "./use-local-storage.Cg5_sjOq.js";
import I from "swr";
import { m as T } from "./mapsTokenFetcher.X7v9oeKD.js";
import { q as _ } from "./index.CVakAlTX.js";
const O = "json", b = {
  "api-version": "1.0",
  countrySet: "US"
}, Z = {
  ...b,
  typeahead: !0,
  limit: 5
}, w = `https://atlas.microsoft.com/search/address/reverse/${O}`, x = (t, s) => {
  if (!t || !s) return null;
  const f = _.stringify(
    { ...b, query: `${t},${s}` },
    {
      addQueryPrefix: !0,
      arrayFormat: "comma"
    }
  );
  return `${w}${f}`;
}, G = (t, s) => {
  const f = x(t, s);
  return I(f, T, {
    revalidateOnFocus: !1,
    keepPreviousData: !0
  });
}, Q = "user.location", V = {
  ADDRESS: "address",
  ZIP_CODE: "zipCode",
  CITY: "city",
  STATE: "state",
  LATITUDE: "latitude",
  LONGITUDE: "longitude"
}, Y = () => {
  const [t, s] = z(
    Q,
    void 0
  );
  return [t, s];
};
function X() {
  const [t, s] = A(), f = k(!1), [m, n] = A(), [, c] = Y(), [r, p] = A(), [o, g] = A(), { t: u } = q(), y = async () => navigator != null && navigator.geolocation ? new Promise((i) => {
    navigator.geolocation.getCurrentPosition(
      (d) => {
        n(void 0);
        const S = d.coords.latitude.toString(), l = d.coords.longitude.toString();
        r === S && o === l ? i({ forceAutofill: !0 }) : (p(S), g(l), i({ forceAutofill: !1 }));
      },
      (d) => {
        switch (d.code) {
          case d.PERMISSION_DENIED:
            n(u("Locations.Errors.AllowAccess"));
            break;
          default:
            n(u("Locations.Errors.GeolocationError"));
            break;
        }
        i({ forceAutofill: !1 });
      }
    );
  }) : (n(u("Locations.Errors.GeolocationNotSupportedError")), { forceAutofill: !1 }), { data: e, error: a, isLoading: L } = G(r, o);
  return M(() => {
    var i, d, S, l, v, P, h, C, D, U, $, R;
    if (a && n(u("Locations.Errors.CantFindLocation")), r && o && !a) {
      const F = {
        latitude: `${r}`,
        longitude: `${o}`,
        address: `${(S = (d = (i = e == null ? void 0 : e.addresses) == null ? void 0 : i[0]) == null ? void 0 : d.address) == null ? void 0 : S.freeformAddress}`,
        city: `${(P = (v = (l = e == null ? void 0 : e.addresses) == null ? void 0 : l[0]) == null ? void 0 : v.address) == null ? void 0 : P.municipality}`,
        state: `${(D = (C = (h = e == null ? void 0 : e.addresses) == null ? void 0 : h[0]) == null ? void 0 : C.address) == null ? void 0 : D.countrySubdivision}`,
        zipCode: `${(R = ($ = (U = e == null ? void 0 : e.addresses) == null ? void 0 : U[0]) == null ? void 0 : $.address) == null ? void 0 : R.postalCode}`
      };
      s(F), N && c && c(F);
    }
  }, [e, a, f.current]), {
    error: m || (a == null ? void 0 : a.message),
    setError: n,
    loading: L,
    onUseMyLocationClick: y,
    userLocation: t
  };
}
const oo = (t) => {
  var p;
  const [s, f] = E.useState({
    ...t
  }), m = E.useRef(void 0), n = _.stringify(
    { ...Z, ...t, query: s.query },
    { addQueryPrefix: !0, arrayFormat: "comma" }
  ), { query: c } = s, r = I(
    c ? [`https://atlas.microsoft.com/search/fuzzy/${O}${n}`] : null,
    T,
    {
      revalidateOnFocus: !1,
      keepPreviousData: !!c && !!m.current && c.startsWith(m.current)
    }
  );
  return E.useEffect(() => {
    m.current = c;
  }, [c]), {
    ...r,
    typeaheadData: ((p = r == null ? void 0 : r.data) == null ? void 0 : p.results.map((o) => {
      var u, y, e, a, L, i;
      const g = {
        address: (u = o == null ? void 0 : o.address) == null ? void 0 : u.freeformAddress,
        city: (y = o == null ? void 0 : o.address) == null ? void 0 : y.municipality,
        state: (e = o == null ? void 0 : o.address) == null ? void 0 : e.countrySubdivision,
        zipCode: (a = o == null ? void 0 : o.address) == null ? void 0 : a.postalCode,
        latitude: (L = o == null ? void 0 : o.position) == null ? void 0 : L.lat.toString(),
        longitude: (i = o == null ? void 0 : o.position) == null ? void 0 : i.lon.toString()
      };
      return {
        id: o.id,
        data: g,
        value: o.address.freeformAddress,
        zipCode: o.address.postalCode
      };
    })) ?? [],
    locationSearchParameter: s,
    setLocationSearchParameter: f
  };
};
export {
  O as A,
  b as D,
  Z as F,
  V as U,
  oo as a,
  G as b,
  Y as c,
  x as g,
  X as u
};
